import { bool, func } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const AutomateBgColorsConfirmation = ({ toggle, setToggle, onClick }) => {
  return (
    <Modal isOpen={toggle} toggle={setToggle} size="md">
      <ModalHeader toggle={setToggle}>Automate Background Colors</ModalHeader>
      <ModalBody>
        Keep in mind that disabling Automate Background Colors will block the
        campaign launch until the creatives are manually set, saved, and synced
        per media set, gender, and product in Creative Factory by the Activation
        Management team. This also applies to content created in Contentful
        (CLM). Even if background colors are set in CLM, if Automate Background
        Colors is set to false, the content must still be saved and synced
        manually in Creative Factory. Do you still want to disable Automate
        Background Colors?
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClick}>
          Yes
        </Button>
        <Button color="secondary" onClick={setToggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AutomateBgColorsConfirmation.propTypes = {
  toggle: bool.isRequired,
  setToggle: func.isRequired,
  onClick: func.isRequired,
};

export default AutomateBgColorsConfirmation;
